
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function CompanyHero() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.05 });

  return (
    <section
      ref={ref}
      className="relative h-[70vh] min-h-[520px] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/ba6564b97453a52d0cc23e81e78ca9ee.jpg"
          alt="BITMOVES JAPAN Office"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />
      </div>

      <div
        className={`relative z-10 text-center px-8 max-w-5xl mx-auto w-full transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <p className="text-sm uppercase tracking-[0.3em] text-white/70 mb-6">
          About Us
        </p>
        <h1 className="text-5xl lg:text-7xl font-light text-white tracking-wide mb-6">
          Company
        </h1>
        <div className="w-16 h-px bg-white/40 mx-auto mb-10" />
        <p className="text-lg text-white/90 leading-relaxed max-w-3xl mx-auto">
          BITMOVES JAPANは東京を拠点に、プロダクト・体験・実装を横断して&ldquo;Making Things&rdquo;を行うクリエイティブプロデュースチームです。
        </p>
      </div>
    </section>
  );
}
